import { TextField, FormControl, InputLabel, OutlinedInput, InputAdornment, Tooltip } from "@mui/material";
import {useRef, useEffect} from 'react';
export default function FormPerformance(props) {
      // Create ref for first input
      const firstInputRef = useRef(null);

      // Focus on first input when component mounts
      useEffect(() => {
          if (firstInputRef.current) {
              firstInputRef.current.focus();
          }
      }, []); // Empty dependency array means this runs once when component mounts
  
    const formatNumber = (num) => {
        if (!num) return '';
        // Remove any existing commas and non-numeric characters except decimal point
        const cleanNum = num.toString().replace(/[^\d.-]/g, '');
        // Format with commas
        return cleanNum.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    const onChange = (e) => {
        const { name, value } = e.target;
        // Remove commas before saving to state
        const cleanValue = value.replace(/,/g, '');
        const finalValue = cleanValue === '' ? 0 : cleanValue;
        props.setSelectedFinancial({ ...props.selectedFinancial, [name]: finalValue });
    }

    const onChecked = (e) => {
        const { name, checked } = e.target;
        props.setSelectedFinancial({ ...props.selectedFinancial, [name]: checked });
    }

    return (
        <>
        <div className="formRow">
            <div className="formGroup">
                <Tooltip title="Current Assets as reported on the balance sheet." arrow placement="top">
                    <FormControl className="formControl">
                        <InputLabel>Current Assets</InputLabel>
                        <OutlinedInput
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            value={formatNumber(props.selectedFinancial.performanceCurrentAssets)}
                            onChange={onChange}
                            name='performanceCurrentAssets'
                            label="Current Assets"
                            inputRef={firstInputRef}
                        />
                    </FormControl>
                </Tooltip>
            </div>
            <div className="formGroup">
                 <Tooltip title="Total Assets as reported on the balance sheet. " arrow placement="top">
                     <FormControl className="formControl">
                        <InputLabel>Total Assets</InputLabel>
                        <OutlinedInput
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            value={formatNumber(props.selectedFinancial.performanceTotalAssets)}
                            onChange={onChange}
                            name='performanceTotalAssets'
                            label="Total Assets"
                        />
                    </FormControl>
                 </Tooltip>
            </div>
            <div className="formGroup">
                 <Tooltip title="Current Liabilities as reported on the balance sheet. " arrow placement="top">
                     <FormControl className="formControl">
                        <InputLabel>Current Liabilities</InputLabel>
                        <OutlinedInput
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            value={formatNumber(props.selectedFinancial.performanceCurrentLiabilities)}
                            onChange={onChange}
                            name='performanceCurrentLiabilities'
                            label="Current Liabilities"
                        />
                    </FormControl>
                 </Tooltip>
            </div>
        </div>
        <div className="formRow">
        <div className="formGroup">
                  <Tooltip title="Total Liabilities as reported on the balance sheet. " arrow placement="top">
                      <FormControl className="formControl">
                        <InputLabel>Total Liabilities</InputLabel>
                        <OutlinedInput
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            value={formatNumber(props.selectedFinancial.performanceTotalLiabilities)}
                            onChange={onChange}
                            name='performanceTotalLiabilities'
                            label="Total Liabilities"
                        />
                    </FormControl>
                  </Tooltip>
                </div>
                <div className="formGroup">
                 <Tooltip title="Equity or Net Worth as reported on the balance sheet." arrow placement="top">
                     <FormControl className="formControl">
                        <InputLabel>Equity</InputLabel>
                        <OutlinedInput
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            value={formatNumber(props.selectedFinancial.performanceEquity)}
                            onChange={onChange}
                            name='performanceEquity'
                            label="Equity"
                        />
                    </FormControl>
                 </Tooltip>
            </div>
            <div className="formGroup">
                
            </div>

        </div>
            
           
           
          
           
        </>
    );
}